var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic24 = function SvgMic24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6a4 4 0 1 1 8 0v5a4 4 0 0 1-8 0V6Zm4-2a2 2 0 0 0-2 2v5a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9a1 1 0 0 1 1 1v1a6 6 0 0 0 12 0v-1a1 1 0 1 1 2 0v1a8.001 8.001 0 0 1-7.002 7.938A.97.97 0 0 1 13 19v2a1 1 0 1 1-2 0v-2c0-.02 0-.041.002-.062A8.001 8.001 0 0 1 4 11v-1a1 1 0 0 1 1-1Z",
    fill: "currentColor"
  })));
};
export default SvgMic24;